import { render, staticRenderFns } from "./AdviserEducationPopup.vue?vue&type=template&id=9e10e7e0&"
import script from "./AdviserEducationPopup.vue?vue&type=script&lang=js&"
export * from "./AdviserEducationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports